import React, { useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, NavLink } from "react-router-dom";
import MobileMenuModal from "./MobileMenuModal";

const HeaderMain = ({ schoolInfo }) => {
  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".eschool-header-sticky");
    const scrollTop = window.scrollY;
    scrollTop >= 150
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };

  return (
    <>
      <header className="eschool-header">
        <div className="eschool-header-top">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <div className="eschool-h-top-notice">
                  <span className="eschool-h-top-notice-title">
                    Latest Notice :
                  </span>
                  <marquee className="eschool-notice-running">
                    {" "}
                    <a href="#">
                      Today E-school is off. Classical Education For The Future.
                      Today E-school is off.
                    </a>
                  </marquee>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="eschool-h-top-details">
                  <ul className="eschool-h-top-contact">
                    <li>
                      <Link to={`tel:${schoolInfo?.hot_number_1}`}>
                        <i className="fi fi-rr-phone-call"></i>
                        {schoolInfo?.hot_number_1}
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={`mailto:${schoolInfo?.email_1}`}>
                        <i className="fi fi-rr-envelope-open"></i>
                        {schoolInfo?.email_1}
                      </Link>
                    </li> */}
                    <li>
                      <i className="fi fi-rr-shield-check"></i>EIN-
                      {schoolInfo?.ein}
                    </li>
                    <li className="header-language-select">
                      <i className="fi-rr-angle-small-down"></i>
                      <select
                        className="form-select "
                        aria-label=".form-select-lg example"
                      >
                        <option selected>English</option>
                        <option value="1">Bangla</option>
                        <option value="2">Arabic</option>
                      </select>
                    </li>

                    <li className="eschool-h-top-accounts">
                      {" "}
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          My Account<i className="fi-rr-angle-small-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="eschool-h-accounts-menu">
                          <Dropdown.Item className="eschool-h-accounts-list">
                            <NavLink to="#">Log in</NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-accounts-list">
                            <NavLink to="#">Forgot password</NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-accounts-list">
                            <NavLink to="#">Logout</NavLink>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="eschool-header-sticky">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-3 col-12">
                <div className="eschool-logo">
                  <Link to="/">
                    <img src={schoolInfo?.school_Logo} alt="#" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-9 col-md-9 col-12">
                <div className="eschool-header-menu">
                  <ul className="eschool-header-menu-list">
                    <li>
                      <NavLink to="/">Home</NavLink>
                    </li>
                    <li>
                      <NavLink to="/aboutus">About</NavLink>
                    </li>
                    <li>
                      <NavLink to="/whystudy">Why study</NavLink>
                    </li>
                    <li>
                      <NavLink to="/facilities">Facilities</NavLink>
                    </li>
                    <li>
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          Admission<i className="fi-rr-angle-small-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="eschool-h-dropdown-menu">
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/applyadmission">
                              Apply admission{" "}
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/admissionguideline">
                              Admission guideline
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/admissionform">
                              Admission form
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/admissionsuspension">
                              Admission suspension
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                    <li className="academic-curriculum-menu">
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          Academic curriculum
                          <i className="fi-rr-angle-small-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="eschool-h-dropdown-menu">
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/academicfees">
                              Academic fees{" "}
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/classbook">
                              Class book
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/classroutine">
                              Class routine
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/examroutine">
                              Exam routine
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                    <li>
                      <NavLink to="/noticeboard">Notice board</NavLink>
                    </li>
                    <li className="header-more-menu">
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          More<i className="fi-rr-angle-small-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="eschool-h-dropdown-menu">
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/studentresults">
                              Student results{" "}
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/blog">
                              Blog/Events
                              <i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                          <Dropdown.Item className="eschool-h-dropdown-list">
                            <NavLink to="/contactus">
                              Contact Us<i className="fi fi-rs-arrow-right"></i>
                            </NavLink>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto">
                <MobileMenuModal />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderMain;
